import { CONSTANTS, COMPONENTS } from '@js/global'
import type { Project } from '@js/components'
import { ActuOptions, ProjectData } from '@js/types'
import { BaseBox, BaseBoxOptions } from './BaseBox'
import { Marquee, getCurrentTime } from '@js/utils'
import css from '@css/sass/styles.module.scss'

export class Actu extends BaseBox {
  private boxBodyText: HTMLHeadingElement | null = null
  private marquee: Marquee | null = null
  private customText: string | string[] | undefined
  private linkedProject: string | undefined

  constructor(options: ActuOptions) {
    const baseOptions: BaseBoxOptions = {
      id: options.data.id,
      title: options.data.title,
      width: CONSTANTS.css.actuWidth,
      widthMin: CONSTANTS.css.actuWidthMin,
      heightOpen: CONSTANTS.css.actuHeight,
      bgAssetKey: 'lignesjaunes.jpg',
      bgFolder: 'motifs',
      bgClass: [css.motifjaune],
      marqueeSpeed: options.data.speed ?? 50,
    }
    super(baseOptions)

    options.object = this
    this.linkedProject = options.data.linkedProject
    this.customText = options.data.text
  }

  protected createContent(): void {
    if (!this.bodyContainer) return

    this.boxBodyText = document.createElement('h2')
    this.boxBodyText.className = `${css.marquee} ${css.unselectable_text}`
    this.bodyContainer.appendChild(this.boxBodyText)

    // Add linked project message
    let texts = this.createLink(this.customText ?? '')

    this.marquee = new Marquee(this.boxBodyText, {
      texts,
      defaultText: () => this.getDefaultMsg(),
      speed: this.options.marqueeSpeed,
      duplicated: true,
      pauseOnHover: true,
    })

    this.marquee.start()
  }

  private createLink(texts: string | string[]): string | string[] {

    const findProject = (projectName: string): Project | null => {

      const projectData = COMPONENTS.projects.data.find(
        (project: ProjectData) => project.name === projectName
      )

      if (!projectData) {
        console.debug("[Actu] no linked project found")
        return null
      }

      const projectClass =
        COMPONENTS.projects.objects.find(
          (p: Project) => p.getData().name === projectData.name
        ) || null

      console.log("[Actu] found linked project:", projectData.name)

      return projectClass
    }

    const buildProjectMessage = (project: Project): string => {
      const data = project.getData()
      return `NEW! NEW! >>> 
        <a href="#" data-project="${data.name}" class="${css.projectLink}">
          ${data.title} 
        </a> 
      <<< NEW! NEW!`
    }

    const createLinkEventListener = () => {
      // create click event listener
      this.boxBodyText?.addEventListener('click', (e) => {
        const target = e.target as HTMLElement
        const projectName = target.dataset.project

        if (!projectName) return

        e.preventDefault()
        const project = COMPONENTS.projects.objects.find(
          p => p.getData().name === projectName
        )

        if (project) {
          project.open()
        }
      })
    }

    // start
    if (this.linkedProject) {
      const project = findProject(this.linkedProject)

      if (project) {
        const linkedMsg = buildProjectMessage(project)
        texts = Array.isArray(texts) ? [linkedMsg, ...texts] : [linkedMsg, texts]
      }
    }
    createLinkEventListener() 

    return texts
  }


  /* -------------------------------------------------------------------------
  |  P U B L I C
  |------------------------------------------------------------------------- */

  updateMsg(msg: string): void {
    this.marquee?.updateText(
      this.customText ? [msg, ...(Array.isArray(this.customText) ? this.customText : [this.customText])] : msg,
    )
  }

  getMsg(): string | string[] | undefined {
    return this.customText
  }

  /* -------------------------------------------------------------------------
  |  H E L P E R S
  |------------------------------------------------------------------------- */

  private getDefaultMsg(): string {
    const [h, m] = getCurrentTime()
    return `Il est <strong>${h}:${m}</strong> sur thasor.fr`
  }
}
